export default __webpack_public_path__ + "static/media/zawody4.a959147e.jpg";